// @flow

import React, { Component } from "react"
import style from "./style.css"
import Card from "../../components/Card"
import LabeledValue from "../../components/LabeledValue"
import Division from "../../components/Division"
import * as strings from "../../strings"
import { formatCurrency } from "../../utils"
import Chip from "react-toolbox/lib/chip/Chip"
import Avatar from "react-toolbox/lib/avatar/Avatar"
import { withRouter } from "react-router-dom"
import Dropdown from "react-toolbox/lib/dropdown/Dropdown"

class DebtSummaryHeader extends Component {

  props: {
    debt: {},
    title: string,
    isProcessPhase: boolean,
    history: any,
    executionId: any,
    plid: string,
    sendNotification: any,
    onChange: () => any,
    phasePaidValue: any,
    phaseUpaidValue: any,
    phaseTotalValue: any,
    unpaidValue: any,
    phaseName: any,
    carteira: any,
  }

  handleChange = managerId => {
    this.props.onChange(managerId)
  }

  isLitigation() {
    return this.props.debt && this.props.debt.litigations && this.props.debt.litigations.length > 0 && this.props.debtPhaseEnum === "Litigation" && this.props && this.props.managers;
  }


  formattedManagers = this.props.managers ? this.props.managers.map((manager, index) => ({
        value: manager.id,
        label: manager.username,
      })) : null


  render() {
    const { debt, plid, manager, managers } = this.props
    const mainDebtor = debt && debt.debtDebtors &&
      debt.debtDebtors.find(debtor => debtor.debtor.id === debt.idDebtor).debtor
    const { generalStrings } = strings

    return (
      <Card decor>
        <Division title={"Dívida".toUpperCase()} />
        <div className={style.wrapper}>
          <div className={style.col}>
            <LabeledValue big label={strings.debtor.title}>
              {(mainDebtor && mainDebtor.contact.name) || generalStrings.emptyField}
            </LabeledValue>
            <LabeledValue big label={strings.debtor.debtorNif}>
              {(mainDebtor && mainDebtor.contact.nif) || generalStrings.emptyField}
            </LabeledValue>

            {this.props.debt.preLitValues && !this.props.isProcessPhase ? <LabeledValue big label="Valor Total Pré-Contencioso (Em curso)">
              {this.props.debt.preLitValues.total || 0} EUR
            </LabeledValue> : ""}

            {this.props.phaseTotalValue ? <LabeledValue big label={`Valor ${this.props.phaseName}`}>
              {formatCurrency(this.props.phaseTotalValue) || generalStrings.emptyField}
            </LabeledValue> : ""}
          </div>
          <div className={style.col}>
            <LabeledValue big label={strings.generalStrings.client}>
              {(debt && debt.client && debt.client.contact.name) || generalStrings.emptyField}
            </LabeledValue>
            <LabeledValue big label={generalStrings.privateLawyersId}>
              {plid || generalStrings.emptyField}
            </LabeledValue>

            {this.props.debt.preLitValues && !this.props.isProcessPhase ? <LabeledValue big label="Valor Total Liquidado">
              {this.props.debt.preLitValues.paid || 0} EUR
            </LabeledValue> : ""}

            {this.props.phasePaidValue ? <LabeledValue big label="Valor Liquidado">
              {formatCurrency(this.props.phasePaidValue) || generalStrings.emptyField}
            </LabeledValue> : ""}
          </div>
          <div className={style.col}>
            <LabeledValue big label={generalStrings.lawyer}>
              {(debt && debt.lawyer && debt.lawyer.contact.name) || generalStrings.emptyField}
            </LabeledValue>

            { this.isLitigation() ? <Dropdown
              auto
              label="Gestor"
              source={this.formattedManagers}
              value={manager.id}
              onChange={(value) => this.handleChange(value)}
            /> : ""}

            {this.props.carteira ? <LabeledValue big label="Carteira">
              {this.props.carteira || generalStrings.emptyField}
            </LabeledValue> : ""}

            {this.props.debt.preLitValues && !this.props.isProcessPhase ? <LabeledValue big label="Valor Total em Dívida">
              {this.props.debt.preLitValues.unpaid || 0} EUR
            </LabeledValue> : ""}

            {this.props.phaseUpaidValue ? <LabeledValue big label="Valor em Dívida (Ref MB)">
              {formatCurrency(this.props.phaseUpaidValue) || generalStrings.emptyField}
            </LabeledValue> : ""}
          </div>
          <div className={style.col}>
            {this.props.isProcessPhase ?
              <Chip style={{ cursor: "pointer" }} onClick={() => this.props.history.push("/debt/" + debt.id)}>
                <Avatar style={{ backgroundColor: "#2196f3" }} icon="folder" />
                <span>Ver processo</span>
              </Chip>
              : null}
            {this.props.executionId ?
              <Chip style={{ cursor: "pointer", "margin-top": "10px" }} onClick={() => this.props.history.push("/execution/" + this.props.executionId)}>
                <Avatar style={{ backgroundColor: "#2196f3" }} icon="folder" />
                <span>Ver execução</span>
              </Chip> : null}
            {this.props.lotId ?
              <Chip style={{ cursor: "pointer", "margin-top": "10px" }} onClick={() => this.props.history.push("/lot/" + this.props.lotId)}>
                <Avatar style={{ backgroundColor: "#2196f3" }} icon="receipt" />
                <span>Ver lote</span>
              </Chip> : null}
            {this.props.sendNotification ?
              <Chip
                style={{ cursor: "pointer", "margin-top": "10px" }}
                onClick={this.props.sendNotification}>
                <Avatar style={{ backgroundColor: "#2196f3" }} icon="mail" />
                <span>Enviar notificação</span>
              </Chip> : null}
          </div>
        </div>
      </Card>
    )
  }
}
export default withRouter(DebtSummaryHeader)



// WEBPACK FOOTER //
// ./src/components/DebtSummaryHeader/index.jsx